import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import { Currency } from "_shared/money/currencies/currency";
import InsuranceInfoSchema, {
  InsuranceInfoJSON,
  InsuranceInfoParams,
} from "marketplace/insurance-info/insurance-info-schema";

export default class InsuranceInfo {
  public static get EXAMPLE(): InsuranceInfo {
    return new InsuranceInfo({
      insuredAmount: 1000000,
      currency: Currency.USD,
    });
  }

  public static create(values: InsuranceInfoParams): InsuranceInfo {
    const parsed = InsuranceInfoSchema.validate(values);
    return new InsuranceInfo(parsed);
  }

  public static fromJSON(json: unknown): InsuranceInfo | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const params = InsuranceInfoSchema.deserialize(json);
    return new InsuranceInfo(params);
  }

  public readonly insuredAmount?: number;
  public readonly currency?: Currency;

  public constructor(params: InsuranceInfoParams) {
    this.insuredAmount = params.insuredAmount;
    this.currency = params.currency ?? Currency.USD;
  }

  public toJSON(): InsuranceInfoJSON {
    return InsuranceInfoSchema.serialize(this);
  }

  public isEqualTo(other: InsuranceInfo): boolean {
    return this.insuredAmount === other.insuredAmount && this.currency === other.currency;
  }

  public toString(): string {
    return `InsuranceInfo (
      insuredAmount: ${this.insuredAmount}
      currency: ${this.currency}
    )`;
  }
}
